import App from './controller/app';
import OrbitalFactory from './controller/OrbitalFactory';
import SessionController from "../js/controller/SessionController";
import Params from './options/Params';
import { Engine } from "@babylonjs/core/Engines/engine";
import { Scene } from "@babylonjs/core/scene";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Color4 } from "@babylonjs/core/Maths/math.color";
import { ArcRotateCamera } from "@babylonjs/core/Cameras/arcRotateCamera";
import { HemisphericLight } from "@babylonjs/core/Lights/hemisphericLight";
import { PointLight } from "@babylonjs/core/Lights/pointLight";
import "@babylonjs/core/Loading/loadingScreen";
import 'pepjs';

{
  console.log("Alchemie Hybridization $package-version");
  console.log("Proprietary and Confidential");
  console.log("Copyright Alchemie 2020-2021");

  let _timeSinceLastRender = 0;
  let _windowIsBackground = false;

  Params.load();

  const canvas = document.getElementById("renderCanvas");
  const engine = new Engine(canvas, true);
  const scene = new Scene(engine);

  if (Params.shared) {
    Params.configuration = Params.promptStart;
  }

  engine.displayLoadingUI();
  engine.hideLoadingUI();

  // engine.renderEvenInBackground = false;

  scene.clearColor = new Color4(0, 0, 0, 0);

  // Add a camera to the scene and attach it to the canvas
  const camera = new ArcRotateCamera("Camera", -Math.PI / 2, Math.PI / 2, 8, new Vector3(0, 0, 0), scene);

  // camera.lowerRadiusLimit = 5;
  // camera.upperRadiusLimit = 10;
  camera.lowerRadiusLimit = 8;
  camera.upperRadiusLimit = 8;
  camera.attachControl(canvas, true);
  camera.inputs.attachedElement = canvas;

  // Add lights to the scene
  const light1 = new HemisphericLight("light1", new Vector3(1, 1, 0), scene);
  const light2 = new PointLight("light2", new Vector3(0, 1, -1), scene);


  // The orbital factory requires XMLHttpRequest and the app expects all models to be loaded
  // by the time it is started. Start it outside the app and pass it into the app to be used.
  const orbitalFactory = new OrbitalFactory(scene);
  const props = { canvas: canvas, orbitalFactory: orbitalFactory }
  const app = new App(scene, props);

  orbitalFactory.load().then(() => {

    app.init();

    // Install external communication handlers.
    window.onmessage = function (e) {
      if (e.data === 'submit') {
        const result = {
          type: 'goal-completed',
          success: app.wasGoalCompleted(),
          name: e.target.name
        }
        window.top.postMessage(result, event.origin);
      } else if (e.data.type == "session-configuration") {
        SessionController.useWatchedConfiguration(e.data.configuration);
      } else if (e.data.type == "remove-session-configuration") {
        SessionController.stopWatching();
      } else if (e.data.type == "submit-assessment") {
        SessionController.submitAssessment();
      } else if (e.data.type == "get-authored-assessment") {
        SessionController.getAuthoredAssessment(app, Params.name);
      } else if (e.data.type == "check-answer") {
        SessionController.sendAssessment();
      } else if (e.data.type == "set-configuration") {
        app.loadConfigurationStringTemp(e.data.configuration);
      }
    }

    if (Params.shared) {
      SessionController.startSession(app, Params.name, Params.sessionState, Params.promptGoals, Params.sessionMode, Params.promptSubmitted);
    }

    window.top.postMessage({ type: "interactive-loaded", name: Params.name }, "*");

    // after 500ms, disable rendering
    setTimeout(() => {
      _windowIsBackground = Params.shared != "true";
    }, 500);
  });

  // Register a render loop to repeatedly render the scene
  // If the window is in the background, then only render once every second
  engine.runRenderLoop(() => {
    const dt = engine.getDeltaTime() / 1000.0;

    if (_windowIsBackground && _timeSinceLastRender < 1) {
      _timeSinceLastRender += dt;
      return;
    }

    _timeSinceLastRender = 0;

    app.render(dt);
  });

  window.addEventListener("blur", () => {
    if (!Params.shared) {
      _windowIsBackground = true;
    }
  });

  // Watch for browser/canvas resize events
  window.addEventListener("resize", () => {
    engine.resize();
  });

  window.addEventListener("keypress", (e) => {
    // if tilde key is pressed
    if (e.keyCode == 96) {
      console.log("copying configuration to clipboard...");

      e.preventDefault();

      const configuration = app.getConfigString();
      const goal = app.getGoalConfiguration();
      const textArea = document.createElement("textarea");
      textArea.style.position = "absolute";
      textArea.style.left = "-1000px";
      textArea.value = `promptStart=${configuration}&promptGoals=${goal}`;

      document.body.appendChild(textArea);

      textArea.select();

      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  });

  window.addEventListener("pointerdown", () => {
    _windowIsBackground = false;
  });

  canvas.addEventListener("create-orbital", (e) => app.createOrbital(e.detail.type));
  canvas.addEventListener("release-orbital", (e) => app.releaseOrbital(e.detail.type));
  canvas.addEventListener("move-orbital", (e) => app.moveOrbital(e.detail.type, e.detail.x, e.detail.y));
  canvas.addEventListener("hybridize", (e) => app.onHybridize());
  canvas.addEventListener("reset", (e) => app.reset());

  document.body.addEventListener("change-atom-count", (e) => app.setAtomCount(e.detail.count));
}
